export default __webpack_public_path__ + "static/media/sanFrancisco49ersVideo-2x.7d0d489a.jpg";